document.addEventListener('DOMContentLoaded', function () {
  // Only run on mobile
  if (window.innerWidth > 767) return;

  var stickyBar = document.querySelector('.sticky-add-cart');

  // Find the real ATC button inside the product form (not the sticky one)
  var realBtn = document.querySelector(
    '.product-detail__information [type="submit"], .product-detail__information .btn-addtocart, .shopify-block.block-product__buttons [type="submit"]'
  );

  if (!stickyBar || !realBtn) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.add('real-atc-visible');
        } else {
          stickyBar.classList.remove('real-atc-visible');
        }
      });
    },
    { threshold: 0.5 }
  );

  observer.observe(realBtn);
});